export const ROLES = {
    MANAGER: "Manager",
    SUPERVISOR: "Supervisor",
    CASHIER: "Cashier",
};
